import Swal from "sweetalert2";
import inMemoryJWT from "../../auth/inMemoryJwt";
import { urlServer } from "../../config/GlobalConstant";

import {
  CREATE_SUB_WINERY_SUCCESS,
  IS_LOADING_CREATE_SUB_WINERY,
  IS_LOADING_DELETE_SUB_WINERY,
  IS_LOADING_LIST_SUB_WINERIES,
  LIST_OF_SUB_WINERIES,
  DELETE_SUB_WINERY_SUCCESS,
  IS_LOADING_UPDATE_SUB_WINERIES,
  EDIT_SUB_WINERY_SUCCESS,
  IS_LOADING_ONLY_SUB_WINERY,
  GET_ONLY_ONE_SUB_WINERY,
  IS_LOADING_SUBWINERIES_BY_NAME,
  LIST_OF_SUBWINERIES_BY_NAME,
  CLEAR_SUB_WINERIES
} from "./types";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2000,
});
export const createSubWinery =
  ({ NSwinery, CSwinery, DSwinery }, Id) =>
  async (dispatch) => {
    dispatch({
      type: IS_LOADING_CREATE_SUB_WINERY,
    });
    await fetch(`${urlServer}wineries/subwineries/create`, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      withCredentials: true,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${inMemoryJWT.getToken()}`,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      }, // body data type must match "Content-Type" header
      body: JSON.stringify({
        wineryId: Id,
        name: NSwinery,
        ubication: { city: CSwinery, state: DSwinery },
      }),
    })
      .then((response) => response.json())
      .then((respJson) => {
        dispatch({
          type: CREATE_SUB_WINERY_SUCCESS,
        });
        if (respJson.success === true) {
          Toast.fire({
            icon: "success",
            title: "Sub-Bodega Creada Correctamente",
          });
        } else {
          if (respJson.error.code === 11000) {
            Toast.fire({
              icon: "error",
              title: "Ya Exite Una Sub-Bodega Con Ese Nombre",
            });
          } else {
            Toast.fire({
              icon: "error",
              title: "Error al Crear",
            });
          }
        }
      })
      .catch((error) => {
        console.log();
      });
  };
export const listSubWineries = () => async (dispatch) => {
  dispatch({
    type: IS_LOADING_LIST_SUB_WINERIES,
  });
  await fetch(`${urlServer}wineries/subwineries/get-all`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJWT.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
    .then((response) => response.json())
    .then((respJson) => {
      dispatch({
        type: LIST_OF_SUB_WINERIES,
        payload: respJson.data,
      });
    })
    .catch((error) => {
      console.log();
    });
};

export const seeSubWineries =
  (textString = "") =>
  async (dispatch) => {
    dispatch({
      //Esto se lo envía a combineReducer, el que está en el index
      type: IS_LOADING_SUBWINERIES_BY_NAME,
    });
    await fetch(
      `${urlServer}wineries/subwineries/search-subwineries-by-name-or-code`,
      {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${inMemoryJWT.getToken()}`,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: JSON.stringify({
          textString: textString,
        }),
      }
    )
      .then((response) => response.json())
      .then((respJson) => {
        dispatch({
          //Esto se lo envía a combineReducer, el que está en el index
          type: LIST_OF_SUBWINERIES_BY_NAME,
          payload: respJson.data,
        });
      })
      .catch((error) => {
        console.log();
      });
  };

  export const clearSubWineries = () => (dispatch) =>{
    dispatch({
      type: CLEAR_SUB_WINERIES,
    })
  }

export const listSubWineriesById = (Id) => async (dispatch) => {
  dispatch({
    type: IS_LOADING_LIST_SUB_WINERIES,
  });
  await fetch(`${urlServer}wineries/subwineries/get-subwineries-by-winery-id`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJWT.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    }, // body data type must match "Content-Type" header
    body: JSON.stringify({
      wineryId: Id,
    }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      dispatch({
        type: LIST_OF_SUB_WINERIES,
        payload: respJson.data,
      });
    })
    .catch((error) => {
      console.log();
    });
};
export const deleteSubWinery = (Id) => async (dispatch) => {
  dispatch({
    type: IS_LOADING_DELETE_SUB_WINERY,
  });
  await fetch(`${urlServer}wineries/subwineries/delete`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJWT.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    }, // body data type must match "Content-Type" header
    body: JSON.stringify({
      subwineryId: Id,
    }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      dispatch({
        type: DELETE_SUB_WINERY_SUCCESS,
        payload: { Id },
      });
      if (respJson.success === true) {
        Toast.fire({
          icon: "success",
          title: "Sub-Bodega Eliminada Correctamente",
        });
      } else {
        Toast.fire({
          icon: "error",
          title: "Error al Eliminar",
        });
      }
    })
    .catch((error) => {
      console.log();
    });
};
export const updateSubWinery = (values, id) => async (dispatch) => {
  dispatch({
    type: IS_LOADING_UPDATE_SUB_WINERIES,
  });
  await fetch(`${urlServer}wineries/subwineries/update`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJWT.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    }, // body data type must match "Content-Type" header
    body: JSON.stringify({
      subwineryId: id,
      wineryId: values.idWinery,
      name: values.NSwinery,
      ubication: { city: values.CSwinery, state: values.DSwinery },
    }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      dispatch({
        type: EDIT_SUB_WINERY_SUCCESS,
        payload: { data: respJson.data },
      });
      if (respJson.success === true) {
        Toast.fire({
          icon: "success",
          title: "Sub-Bodega Actualizada Correctamente",
        });
      } else {
        Toast.fire({
          icon: "error",
          title: "Error al Actualizar",
        });
      }
    })
    .catch((error) => {
      console.log();
    });
};
export const getOneSubWineryById = (id) => async (dispatch) => {
  dispatch({
    type: IS_LOADING_ONLY_SUB_WINERY,
  });
  await fetch(`${urlServer}wineries/subwineries/get-one-by-id`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJWT.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    }, // body data type must match "Content-Type" header
    body: JSON.stringify({
      subwineryId: id,
    }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      dispatch({
        type: GET_ONLY_ONE_SUB_WINERY,
        payload: { data: respJson.data },
      });
    })
    .catch((error) => {
      console.log();
    });
};
